import { apiDelete } from "../client";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { QueryKeys } from "@/lib/query-keys";

/**
 * 그룹 삭제 API 함수
 * @param id 삭제할 그룹의 ID
 * @returns API 응답
 */
export const apiDeleteGroup = async (id: string) => {
  const response = await apiDelete(`/groups/${id}`);
  return response;
};

/**
 * 그룹 삭제 React Query 훅
 * @returns 뮤테이션 객체
 */
export const useDeleteGroup = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (id: string) => apiDeleteGroup(id),
    onSuccess: (_, id) => {
      // 전체 그룹 목록 무효화
      queryClient.invalidateQueries({ queryKey: QueryKeys.group.all });
      queryClient.invalidateQueries({ queryKey: QueryKeys.group.list() });
      // 삭제된 그룹 상세 정보 무효화
      queryClient.invalidateQueries({ queryKey: QueryKeys.group.detail(id) });
    },
  });
};

export default useDeleteGroup;
